import {IFilterFunction} from "angular";
import {OrderSide} from "../models/OrderRecord";

export const SidePipeId = "tfSide";
export const SideShortPipeId = "tfSideShort";

export function sidePipe(): IFilterFunction {
    return (value: OrderSide | null) => {
        if (value == null) {
            return null;
        }

        return `side.${value}`;
    };
}

export function sideShortPipe(): IFilterFunction {
    return (value: OrderSide | null) => {
        if (value == null) {
            return null;
        }

        return `side-short.${value}`;
    };
}
